// Expandable and collapsible, multiple times.

// - Must be used together with all the styling classes in expandable.scss
// - Can be used with any extra CSS (e.g. expandable_box) as long as
//   `expandTransitionInnerWrapper` element is a direct and only child of `expandTransitionOuterWrapper`,

up.compiler('.js-expandable__button', button => {
  const expand = (expandTransitionOuterWrapper, expandTransitionInnerWrapper) => {
    button.setAttribute('aria-expanded', 'true')

    requestAnimationFrame(() => {
      expandTransitionInnerWrapper.style.display = 'block'

      requestAnimationFrame(() => {
        expandEnter(expandTransitionOuterWrapper, expandTransitionInnerWrapper)

        expandTransitionOuterWrapper.addEventListener(
          'transitionend',
          () => {
            expandAfterEnter(expandTransitionOuterWrapper)
          },
          { once: true }
        )
      })
    })
  }

  const collapse = (expandTransitionOuterWrapper, expandTransitionInnerWrapper) => {
    button.setAttribute('aria-expanded', 'false')

    requestAnimationFrame(() => {
      expandBeforeLeave(expandTransitionOuterWrapper, expandTransitionInnerWrapper)

      requestAnimationFrame(() => {
        expandLeave(expandTransitionOuterWrapper)

        expandTransitionOuterWrapper.addEventListener(
          'transitionend',
          () => {
            expandTransitionInnerWrapper.style.display = 'none'
          },
          { once: true }
        )
      })
    })
  }

  const expandEnter = (expandTransitionOuterWrapper, expandTransitionInnerWrapper) => {
    expandTransitionOuterWrapper.style.height = expandTransitionInnerWrapper.getBoundingClientRect().height + 'px'
  }

  const expandAfterEnter = expandTransitionOuterWrapper => {
    expandTransitionOuterWrapper.style.height = 'auto'
  }

  const expandBeforeLeave = (expandTransitionOuterWrapper, expandTransitionInnerWrapper) => {
    expandTransitionOuterWrapper.style.height = expandTransitionInnerWrapper.getBoundingClientRect().height + 'px'
  }

  const expandLeave = expandTransitionOuterWrapper => {
    // force repaint
    expandTransitionOuterWrapper.offsetHeight

    expandTransitionOuterWrapper.style.height = '0'
  }

  const onClick = () => {
    const el = button.closest('.js-expandable')
    const expandTransitionOuterWrapper = el.querySelector('.js-expandable__expand_transition_outer_wrapper')
    const expandTransitionInnerWrapper = el.querySelector('.js-expandable__expand_transition_inner_wrapper')

    if (button.getAttribute('aria-expanded') === 'true') {
      collapse(expandTransitionOuterWrapper, expandTransitionInnerWrapper)
    } else {
      expand(expandTransitionOuterWrapper, expandTransitionInnerWrapper)
    }
  }

  const init = () => {
    button.addEventListener('click', onClick)

    return () => {
      button.removeEventListener('click', onClick)
    }
  }

  return init()
})
